import { useContext } from 'react';

import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';

import { View } from './homeRouteParams';

export const useSelectedView: () => View = () => {
	const { match } = useContext(RoutesContext);
	const view = match?.params?.view as View;
	return Object.values(View).includes(view) ? view : View.OVERVIEW;
};
